import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import { RUN_STATUS } from "@/profitability/constants";
import type { EnrichedProfitabilityPeriod } from "@/profitability/types";
// The API owns summary order and labels. Web formats their values.
const ReportResult = ({ run }: { run: EnrichedProfitabilityPeriod }) => {
  if (run.status !== RUN_STATUS.completed || !run.summary.length)
    return <span className="text-tertiary-text">—</span>;

  const [headline] = run.display.summary;
  return (
    <Stack gap="none">
      <span className="font-medium">
        {headline.displayValue}
        <span className="ml-1.5 text-xs font-normal text-tertiary-text">
          {headline.inlineLabel}
        </span>
      </span>
      {!!run.display.supportingFigures && (
        <span className="text-xs text-tertiary-text">
          {run.display.supportingFigures}
        </span>
      )}
    </Stack>
  );
};

export const resultCol: ColumnDef<EnrichedProfitabilityPeriod> = {
  id: "result",
  header: "Result",
  // Figures can differ between published versions, so results are not sortable.
  enableSorting: false,
  meta: { size: "230px" },
  cell: ({ row }) => <ReportResult run={row.original} />,
};
